import { IFilteringExpressionsTree, ISortingExpression } from '@infragistics/igniteui-angular';

import { GridColumnConfig } from '../../components/paged-grid/models/grid-column.config';
import { GridStoredPagingConfig } from './grid-stored-paging.config';

export class GridStoredConfig {
    filters?: IFilteringExpressionsTree;
    columns?: GridColumnConfig[];
    sorting?: ISortingExpression[];
    paging?: GridStoredPagingConfig;
    selection?: any[];

    constructor(init?: GridStoredConfig) {
        Object.assign(this, init);
    }
}
